import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {environment} from '../../../environments/environment';
import {CamerallaAuthService} from '../services/authentication-services/cameralla-auth.service';

@Component({
    selector: 'app-logout',
    templateUrl: './logout.component.html',
})
export class LogoutAllComponent implements OnInit {
    public site = environment['site'];

    constructor(private authService: CamerallaAuthService, private router: Router) {
    }

    ngOnInit() {
        if (this.authService.isAuthenticated()) {
            this.authService.logout().then(
                response => window.location.href = this.site + 'wp-login.php?action=logout'
            );
        } else {
            window.location.href = this.site + 'wp-login.php?action=logout';
        }
    }
}
